import {Contact, ContactPhoneNumber} from "models"
import {Pressable, View} from "react-native"
import React, {useEffect, useMemo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import AppHistory from "shared/history"
import ContactPhoneNumbersTable from "components/contact-phone-numbers/table"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import memo from "set-state-compare/build/memo"
import Nav from "./nav"
import Routes from "shared/routes"
import {useAdminLayout} from "components/admin/layout"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import useModel from "@kaspernj/api-maker/build/use-model"
import {useParams} from "@kaspernj/api-maker/build/router/route"

/** @typedef {object} RoutesAdminContactsPhoneNumbersProps */

/** @typedef {object} RoutesAdminContactsPhoneNumbersState */

/**
 * @extends {ShapeComponent<RoutesAdminContactsPhoneNumbersProps, RoutesAdminContactsPhoneNumbersState>}
 */
class RoutesAdminContactsPhoneNumbers extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.contacts.phone_numbers"})
    const params = useParams()
    const {contact, contactId} = useModel(Contact, {
      match: {params},
      select: {
        Contact: ["contactPointsCount", "id"]
      }
    })
    const contactPhoneNumbersQuery = useMemo(() => ContactPhoneNumber.ransack({contact_id_eq: contactId}), [contactId])

    const adminLayout = useAdminLayout()

    this.contact = contact
    this.contactPhoneNumbersQuery = contactPhoneNumbersQuery
    this.contactId = contactId

    useEffect(() => {
      adminLayout?.setState({actions: this.actions(), active: "contacts", headerTitle: t(".phone_numbers")})
    }, [adminLayout, contactId, t])
  }

  render() {
    const {contact, contactPhoneNumbersQuery} = this.tt

    return (
      <View dataSet={this.rootViewDataSet ||= {route: "admin/contacts/phone-numbers"}}>
        {contact &&
          <Nav active="phone-numbers" contact={contact} style={this.navStyle ||= {marginBottom: 10}} />
        }
        <ContactPhoneNumbersTable collection={contactPhoneNumbersQuery} />
      </View>
    )
  }

  actions = () => <>
    <Pressable dataSet={this.addPhoneNumberPressableDataSet ||= {class: "add-phone-number-action"}} onPress={this.tt.onAddPhoneNumberPress}>
      <Icon name="pen" version="FontAwesome6" />
    </Pressable>
  </>

  onAddPhoneNumberPress = () => AppHistory.push(Routes.newAdminContactPhoneNumberPath({contact_phone_number: {contact_id: this.tt.contactId}}))
}

export default memo(shapeComponent(RoutesAdminContactsPhoneNumbers))
